import {FormattedMessage, injectIntl} from '@meiko/react-intl';
import PanelHeaderTitle from 'components/generic/PanelHeaderTitle';
import Panel from 'components/generic/Panel';
import useWindowWidth from 'hooks/windowWidth';
import React from 'react';
import Chart from 'react-chartjs-2';
import {compose} from 'redux';

const OffersChart = ({data, intl}) => {
	const {width: windowWidth} = useWindowWidth();

	const datasByType = data.reduce((acc, row) => {
		(row?.values ?? []).forEach(({label, value}) => {
			const cur = acc[label] ?? [];
			acc[label] = [...cur, value];
		});
		return acc;
	}, {});

	const targetSum = data.reduce((acc, entry) => acc + entry.target, 0);

	const options = {
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
			},
		},
		maintainAspectRatio: false,
		plugins: {
			tooltip: {
				callbacks: {
					label: function (context) {
						return ` ${intl.formatMessage({id: '{num} pcs.'}, {num: context.raw})}`;
					},
				},
			},
		},
	};

	const chartData = {
		labels: data.map(entry => entry.columnLabel),
		datasets: [
			{
				type: 'line',
				label: `${intl.formatMessage({id: 'Dashboard target'})} (${intl.formatMessage(
					{id: '{num} pcs.'},
					{num: targetSum},
				)})`,
				borderColor: 'rgb(255, 99, 132)',
				borderWidth: 2,
				fill: false,
				data: data.map(entry => entry.target),
				datalabels: {
					display: false,
				},
			},
			...Object.keys(datasByType).map((key, index) => {
				const d = datasByType[key];
				const total = d.reduce((acc, cur) => acc + cur, 0);
				return {
					type: 'bar',
					label: `${key} (${intl.formatMessage({id: '{num} pcs.'}, {num: total})})`,
					backgroundColor: `rgba(75, 192, 192, ${1 - index * 0.2})`,
					data: d,
					borderColor: 'transparent',
				};
			}),
		],
	};

	return (
		<Panel
			header={
				<PanelHeaderTitle>
					<FormattedMessage id="Offers target - realization" />
				</PanelHeaderTitle>
			}
		>
			<Chart
				type="bar"
				height={windowWidth > 800 ? 300 : 250}
				data={chartData}
				options={options}
			/>
		</Panel>
	);
};

export default compose(injectIntl)(OffersChart);
